import React, { useEffect, useState } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import img01 from '../../assets/img01.png';
import Button from '../Button';
import ProjectCard from '../ProjectCard';
import ModalContainer from '../ModalContainer';
import CreatProjectModal from '../CreatProjectModal';
import { ProjectSectionStyled, PageHeader, InfoProject, ProjectCardHolder } from './ProjectsSection.styles';
import projectService from '../../services/projectService';
import Loaders from '../Loaders';
import { useQuery } from '@tanstack/react-query';

const ProjectsSection = () => {
  const getAllProjects = useQuery({
    queryKey: ['get_all_projects'],
    queryFn: () => projectService.getProjects(),
    staleTime: Infinity,
  });

  return (
    <>
      <ProjectSectionStyled>
        <PageHeader>
          <div className="text-box">
            <h1>Projects</h1>
            <p>Stay organized and productive by grouping your chats into Projects — with your team or just for you.</p>
          </div>
          <ModalContainer
            width="750"
            title="Create a Project"
            content={({ onClose }) => <CreatProjectModal onClose={onClose} />}
            btnComponent={({ onClick }) => (
              <Button variant="secondary" width="165px" onClick={onClick}>
                <AiOutlinePlusCircle size="18" /> Create Project
              </Button>
            )}
          />
        </PageHeader>
        <div className="text-box">
          <strong className="title">Your Projects</strong>
        </div>
        {/* <InfoProject>
          <div className="img-holder">
            <img src={img01} alt="img" />
          </div>
          <div className="text-holder">
            <strong className="title">Getting started with projects</strong>
            <p>
              Want to group your market research by client? Or organize milestone deliverables? Projects are for you.
            </p>
            <Button width="220px">Create your first project</Button>
          </div>
        </InfoProject> */}
        {/* <div className="text-box">
          <strong className="title">Projects</strong>
        </div> */}
        {getAllProjects?.isPending ? (
          <Loaders loading />
        ) : (
          <ProjectCardHolder>
            <ProjectCard projectCardsData={getAllProjects?.data?.detail} />
          </ProjectCardHolder>
        )}
      </ProjectSectionStyled>
    </>
  );
};

export default ProjectsSection;
